<template>
    <div class="w-100 h-100">
        <div class="h-100 w-100">
            <p v-show="true" class="text-muted body-2 mt-1 description-placeholder">
                {{ $t(params.description || '') }}
            </p>
            <input type="file"
                   ref="fileu"
                   v-on:change="handleFileUpload()"
                   style="position: absolute;top: -90000px" />
            <v-text-field ref="filename" v-if="editable"
                          clearable
                          :placeholder="$t(params.label)"
                          :label="isInGrid ? '' : label"
                          :background-color="editable && !disabled ? 'white' : 'grey lighten-3'"
                          :disabled="disabled || processing"
                          :error="error"
                          :class="{fielderror:error}"
                          outlined
                          readonly
                          hide-details
                          :dense="isInGrid"
                          class="mb-2"
                          @click:clear="clearFile()"
                          :loading="processing"
                          :append-icon="approved == false ? 'mdi-timer-sand' : ''"
                          :value="filenamefield | FormatFileName($t(params.label))" />
            <v-btn v-if="editable && !disabled" :disabled="processing" depressed tile small @click="fileselect()" color="secondary" class="mr-2 white--text">
                <v-icon left small>attachment</v-icon>
                {{ params.newFileLabel != undefined ? $t(params.newFileLabel) : filenamefield == '' ? '' : $t("AL_New") + ' ' }}  {{  params.newFileLabel != undefined ? '' : $t("AL_SelectFile") }}
            </v-btn>
            <v-btn v-if="uploaded" :disabled="processing" depressed tile small @click="showFile()" color="secondary" class="mr-2 white--text">
                <v-icon left small>visibility</v-icon>
                {{ params.showFileLabel != undefined ? $t(params.showFileLabel) : $t("AL_View") }}
            </v-btn>
            <div v-else-if="!editable" :disabled="processing" class="body-2 font-weight-thin unspecified font-italic">
                {{ $t('ST_Undefined') }}
            </div>
            <v-btn v-if="params.draft" :disabled="processing" depressed tile small @click="showDraft()" color="secondary" class="white--text">
                <v-icon left small>mdi-file-document</v-icon>
                {{ params.draftLabel != undefined ? $t(params.draftLabel) : $t("AL_ShowDraft") }}
            </v-btn>
        </div>
    </div>
</template>
<style>
    .fielderror {
        border-color: red !important;
    }
    .description-placeholder {
      min-height: 1.2em;
    }
</style>

<script>
    /*
    Eklenecek: Dosya seçilince Upload çıkacak, dosya boşsa 2. icon olmayacak, yüklenmiş dosya varsa göster iconu çıkacak
    1-) İnit: dosya varsa göster. Boşsa gösterme
    2-) dosya seçilince "göster" kalkacak, Yükle çıkacak
    3-) dosya yüklenince göster görünecek
    */
    import axios from "axios";
    import Utilities from '@/Utilities.js'

    import showdialog from '@/components/ShowDialog.vue';

    export default {
        name: "upload",
        data()
        {
            return {
                file: "",
                filenamefield: "",
                alertMessage: "",
                uploaded: false,
                initialValue: '',
                processing: false,
                maxFileSize: 0,
            };
        },
        props: {
            params: Object,
            label: String,
            invalue: String,
            editable: Boolean,
            disabled: Boolean,
            error: Boolean,
            approved: Boolean,
            isInGrid: { type: Boolean, default: false }
        },
        mounted()
        {
            this.processing = false;
            //Utilities.log("---upload Mounted invalue" + JSON.stringify(this.invalue));
            this.filenamefield = this.invalue || "";
            this.initialValue = this.filenamefield;
            this.uploaded = this.filenamefield != "" && this.filenamefield != undefined;
            this.file = this.filenamefield;
            var stat = this.uploaded ? 'FileUploaded' : 'NoFile'
            var payload = { attributeName: 'UploadStatus', value: stat };
            Utilities.log("Upload Emit changeAttribute", payload)
            this.$emit("changeAttribute", payload);

            const payloadMaxFileSize = { action: 'GetMaxFileSize', data: [] };
            this.$store.dispatch("RunTime", payloadMaxFileSize)
                .then(response =>
                {
                    Utilities.log("Runtime success result:", response);
                    this.maxFileSize = parseInt(response.data.runTimeResult[0].MaxFileSize);
                    console.log("MaxFileSize (Bytes):", this.maxFileSize);
                })
                .catch(err =>
                {
                    this.maxFileSize = 30 * 1024 * 1024;
                    Utilities.log("Runtime error result:", err);
                });
        },

        watch: {
            invalue: function (val, old)
            {
                //   Utilities.log(
                //     "File Watch:" + this.params.name + " Val:" + val + " Old:" + old
                //   );
                this.value = val;
                this.filenamefield = val;
                this.file = val;
                this.uploaded = this.filenamefield != "" && this.filenamefield != undefined;
                var stat = this.uploaded ? 'FileUploaded' : 'NoFile'
                var payload = { attributeName: 'UploadStatus', value: stat };
                Utilities.log("Upload Emit changeAttribute", payload)
                this.$emit("changeAttribute", payload);
            },
            processing: function (newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    this.$emit('changeProcessing', newVal);
                }
            }
        },
        methods: {
            submitFile: function ()
            {
                const self = this;

                self.processing = true;
                Utilities.log("Upload");
                let formData = new FormData();
                console.log("File Size:", self.file.size)

                if (self.file.size > self.maxFileSize)
                {
                    const userFileSizeMb = (self.file.size / (1024 * 1024)).toFixed(0);
                    const maxFileSizeMb = (self.maxFileSize / (1024 * 1024)).toFixed(0);

                    var em = self.$root.$i18n.t('FileIsTooLargeWithSize', { 0: userFileSizeMb, 1: maxFileSizeMb });
                    var messages = {
                        errors: [em],
                        infoBody: '',
                        messageType: 'E',
                        viewType: 'notification',
                    };
                    self.$root.$emit('setUpDialog', messages);
                    self.clearFile();
                    return;
                }
                formData.append("file", self.file);
                axios
                    .post(
                        "/api/upload",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    )
                    .then(function (response)
                    {
                        try
                        {
                            self.processing = false;
                            Utilities.log("SUCCESS File uploaded:", response);
                            let file = response.data.url;//  .data.files[0].url;
                            Utilities.log("File:" + file);
                            var error = response.data.error || "";
                            if (error != "")
                            {
                                var em = self.$root.$i18n.t(error);
                                var messages = {
                                    errors: [em],
                                    infoBody: '',
                                    messageType: 'E',
                                    viewType: 'notification',
                                };
                                self.$root.$emit('setUpDialog', messages);
                                self.clearFile();
                                return;
                            }
                            var payload = { fieldName: self.params.name, fieldValue: file };
                            self.$emit("change", payload);
                            self.file = file;
                            self.uploaded = true;
                            var payload = { attributeName: 'UploadStatus', value: 'FileUploaded' };
                            Utilities.log("Upload Emit changeAttribute", payload)
                            self.$emit("changeAttribute", payload);

                        } catch (e)
                        {
                            Utilities.log("file upload exception:" + e);
                        }
                    })
                    .catch(function ()
                    {
                        Utilities.log("FAILURE!!");
                    });
            },

            handleFileUpload: function ()
            {
                Utilities.log("clicked");
                this.file = this.$refs.fileu.files[0];
                Utilities.log("File Selected:" + JSON.stringify(this.file.name));
                this.filenamefield = this.file.name;
                var payload = { attributeName: 'UploadStatus', value: 'FileSelected' };
                Utilities.log("Upload Emit changeAttribute", payload)
                this.$emit("changeAttribute", payload);
                this.submitFile();
            },
            fileselect: function ()
            {
                this.uploaded = false;
                Utilities.log("this.filenamefield :" + this.filenamefield);
                if ((this.filenamefield || '') == "")
                {
                    this.$refs.fileu.click();
                    Utilities.log("File:" + JSON.stringify(this.$refs.fileu));
                } else
                {
                    this.filenamefield = "";
                    //var payload = { fieldName: this.params.name, fieldValue: '' };
                    //this.$emit("change", payload);
                    this.$refs.fileu.value = '';
                    var payload = { attributeName: 'UploadStatus', value: 'FileDeleted' };
                    Utilities.log("Upload Emit changeAttribute", payload)
                    this.$emit("changeAttribute", payload);
                    this.fileselect();
                }
            },
            clearFile: function ()
            {
                this.processing = false;
                this.value = '';
                this.uploaded = false;
                this.filenamefield = "";
                this.$refs.fileu.value = '';
                var payload = { fieldName: this.params.name, fieldValue: '' };
                this.$emit("change", payload);
                this.file = '';
                var payload = { attributeName: 'UploadStatus', value: 'FileDeleted' };
                Utilities.log("Upload Emit changeAttribute", payload)
                this.$emit("changeAttribute", payload);
            },
            showFile: function ()
            {
                //alert("Show file:" + this.filenamefield);
                var url = "/api/showfile?file=" + encodeURIComponent(this.file);
                window.open(url);
            },
            showDraft: function ()
            {
                //alert("Show file:" + this.filenamefield);
                var url = "/" + this.$root.$i18n.t(this.params.draft);
                window.open(url);
            },
            RollBack: function ()
            {
                this.filenamefield = this.initialValue;
                this.uploaded = this.filenamefield != "";
                //var payload = { fieldName: this.params.name, fieldValue: this.initialValue };
                //this.$emit("change", payload);
            }
        },
        filters: {
            FormatFileName: function (value, label)
            {
                var result = "";
                if (!value) return "";
                Utilities.log("format filename:" + value);
                var parts = value.split("__");
                if (parts.length >= 2)
                {
                    result = value.replace(parts[0] + "__", "");
                }
                else
                {
                    parts = value.split(".");
                    if (parts.length > 0)
                    {
                        result = label + "." + parts[parts.length - 1];
                    }
                    else
                    {
                        result = value;
                    }
                }
                return result;
            }
        },
        computed: {
            SelectIcon: function ()
            {
                var icon = "";
                if ((this.filenamefield || '') != "")
                {
                    icon = "refresh";
                } else
                {
                    icon = "attachment";
                }
                return icon;
            }
        }
    };
</script>
